//let baseUrl = 'http://localhost/rest/';
let baseUrl = 'https:/rest.sangkilsoft.id/';
//let baseUrl = 'https://www.sangkilsoft.id/rest-abuds/';
//let baseUrl = 'https://www.sangkilsoft.id/rest-champion/';

export default {
    name    : 'Biz4',
    apps    : 'main',
    rest    :  baseUrl + 'api/web/index.php/v01/',    
    img     :  baseUrl + 'frontend/web/img/',   
    title   : 'Biz 4 Main',
    prefix  : 'biz4',
    color   : 'light-green',
    file    :  function(route, id){
      return baseUrl + 'frontend/web/index.php/site/' + route + '?refd='+btoa(id);   
    }
} 


